import React from 'react'
interface SectionHeaderProps {
	title: string;
	text?: string;
}
const SectionHeader = ({ title, text }: SectionHeaderProps) => {
	return (
		<div>
			<h2 data-aos="fade-down" className=' xs:text-2xl md:text-4xl font-semibold pb-2'>{title}</h2>
			<p data-aos="fade-down" data-aos-delay="100" className='xs:text-base md:text-lg text-textSecond'>{text}</p>
		</div>
	)
}

export default SectionHeader